<script>
export default {
  data: () => ({
    show: false,
  }),
  mounted() {
    this.show = this.$core.permission.has(359);
    if (!this.show) {
      this.$core.notify.error('У Вас нет прав');
    }
  },
};
</script>
<template>
  <router-view v-if="show"></router-view>
</template>
